import { useState } from "react";

function readPersisted(key: string, fallback: boolean): boolean {
  try {
    const val = localStorage.getItem(key);
    return val !== null ? val === "true" : fallback;
  } catch { return fallback; }
}

export function useToggle(defaultState = false, storageKey?: string) {
  const [state, setState] = useState(() =>
    storageKey ? readPersisted(storageKey, defaultState) : defaultState
  );
  const toggle = () =>
    setState((prev) => {
      const next = !prev;
      if (storageKey) {
        try { localStorage.setItem(storageKey, String(next)); } catch {}
      }
      return next;
    });

  return [state, toggle] as const;
}
